import { useSiteConfig } from "@/hooks/useSiteConfig";
import dominicanSolLogo from "@/assets/dominican-sol-logo.png";

const LogoText = ({ className = "h-12", useFooterLogo = false }: { className?: string; useFooterLogo?: boolean }) => {
  const { getConfig } = useSiteConfig();
  
  const logoConfig = getConfig(useFooterLogo ? 'footer_logo' : 'header_logo');
  const logoUrl = logoConfig?.url || dominicanSolLogo;
  const logoAlt = logoConfig?.alt || 'Dominican Sol Transfers';

  return (
    <div className={`${className} flex items-center`}>
      <img 
        src={logoUrl} 
        alt={logoAlt}
        className={className}
        style={{ objectFit: 'contain' }}
      />
    </div>
  );
};

export default LogoText;